export default __webpack_public_path__ + "static/media/teacher1.8408c4cf.png";